<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <h4>Email Subject</h4>
  </div>
  <div class="cell small-12">
    <textarea [(ngModel)]="conf.subject.content" (blur)="subjectChanged()" (keyup.enter)="subjectChanged()">

    </textarea>
  </div>
  @for (tr of conf.subject.transforms; track tr) {
    <div class="cell small-12">
      <label>{{tr.name}} <input type="text" [(ngModel)]="tr.expression" /></label>
    </div>
  }
  <div class="cell small-12">
    <h4>To:</h4>
  </div>
  @for (a of conf.toAddressRules; track a; let i = $index) {
    <div class="cell small-12">
      <label>Rule: <input type="text" [(ngModel)]="a.expression" /></label>
      @if (i > 0) {
        <button (click)="removeToAddressRule(i)">Remove</button>
      }
    </div>
  }
  <div class="cell small-12">
    <button (click)="addToAddressRule()">Add To Address</button>
  </div>


  <div class="cell small-12">
    <h4>CC:</h4>
  </div>
  @for (a of conf.ccAddressRules; track a; let i = $index) {
    <div class="cell small-12">
      <label>Rule: <input type="text" [(ngModel)]="a.expression" /></label>
      <button (click)="removeCCAddressRule(i)">Remove</button>
    </div>
  }
  <div class="cell small-12">
    <button (click)="addCCAddressRule()">Add CC Address</button>
  </div>

  <div class="cell small-12">
    <h4>Email Body</h4>
  </div>
  <div class="cell small-12">
    <textarea [(ngModel)]="conf.body.content" (blur)="bodyChanged()" (keyup.enter)="bodyChanged()">

    </textarea>
  </div>
  @for (tr of conf.body.transforms; track tr) {
    <div class="cell small-12">
      <label>{{tr.name}} <input type="text" [(ngModel)]="tr.expression" /></label>
    </div>
  }

</div>